import { TextField } from '@mui/material'
import React from 'react'

const CustomDateInput = ({ onFocus, value, onChange, label, disabled, sx, error, helperText }) => {
    return (
        <TextField variant="outlined" fullWidth label={label} onFocus={onFocus} value={value} onChange={onChange} disabled={disabled} sx={sx} error={error} helperText={helperText} />
    )
}

export default CustomDateInput